import { forwardRef, type Ref, type SVGProps } from "react";
const IconSchoolAlternateOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path fill="currentColor" d="M16 11a1.5 1 0 1 0 0 2 1.5 1 0 1 0 0-2" />
    <path
      fill="currentColor"
      d="M29.6 11.56 17 7.14A3.3 3.3 0 0 0 16 7a3.2 3.2 0 0 0-1 .14L2.42 11.56c-.54.19-.54.5 0 .69L15 16.67a3 3 0 0 0 1 .14 3 3 0 0 0 1-.14l5-1.76v5.54a.4.4 0 0 1 0 .11c-.23.36-1.72 2.44-6 2.44s-5.75-2.08-6-2.44v-3.48l-2-.7v4.12a2.6 2.6 0 0 0 .22.95S10 25 16 25s7.78-3.55 7.78-3.55a2.6 2.6 0 0 0 .22-.95v-6.29l2-.7v7.55a.94.94 0 0 0 .94.94h.12a.94.94 0 0 0 .94-.94v-8.25l1.6-.56c.53-.19.53-.5 0-.69m-13.26 3.22a1.4 1.4 0 0 1-.33 0 1.2 1.2 0 0 1-.32 0l-8.2-2.87L15.68 9A1.4 1.4 0 0 1 16 9a1.2 1.2 0 0 1 .32 0l8.2 2.88z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSchoolAlternateOutlineSVG);
ForwardRef.displayName = "IconSchoolAlternateOutline";
export { ForwardRef as IconSchoolAlternateOutline };
